export class GetIngestionPipelineErrorsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "errorClasses",
            "baseName": "errorClasses",
            "type": "Array<IngestionPipelineErrorClass>",
            "format": ""
        },
        {
            "name": "podsScanned",
            "baseName": "podsScanned",
            "type": "number",
            "format": ""
        },
        {
            "name": "podsFailed",
            "baseName": "podsFailed",
            "type": "number",
            "format": ""
        },
        {
            "name": "streamsScanned",
            "baseName": "streamsScanned",
            "type": "number",
            "format": ""
        },
        {
            "name": "streamsFailed",
            "baseName": "streamsFailed",
            "type": "number",
            "format": ""
        },
        {
            "name": "eventsScanned",
            "baseName": "eventsScanned",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceCoverageTruncated",
            "baseName": "sourceCoverageTruncated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resultClassesTruncated",
            "baseName": "resultClassesTruncated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "oldestReturnedAt",
            "baseName": "oldestReturnedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "windowSeconds",
            "baseName": "windowSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "asOf",
            "baseName": "asOf",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GetIngestionPipelineErrorsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
